<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>{{ $t('enum.offer') }}</h2>
      <div class="input_blue">
        <el-input :placeholder="$t('enum.searchForItems')" v-model="searchKey" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="getData()"></el-button>
        </el-input>
      </div>
    </div>
    <div class="main_tabs_box">
      <ul class="main_tabs">
        <li @click="MsgTabs(1)" :class="type == 1 ? 'on' : ''">
          {{ $t('enum.all') }} 
          <!-- <span v-if="Count>0">({{Count}})</span> -->
        </li>
        <li @click="MsgTabs(2)" :class="type == 2 ? 'on' : ''">
          {{ $t('enum.toReply') }}
          <span v-if="toBeAnsweredCount>0">({{toBeAnsweredCount}})</span>
        </li>
        <li @click="MsgTabs(4)" :class="type == 4 ? 'on' : ''">
          {{ $t('enum.replied') }}
          <!-- <span v-if="answeredCount>0">({{answeredCount}})</span> -->
        </li>
        <li @click="MsgTabs(3)" :class="type == 3 ? 'on' : ''">
          {{ $t('enum.sold') }}
          <!-- <span v-if="dealCount>0">({{dealCount}})</span> -->
        </li>
      </ul>
    </div>
    <table-list :list="List" :tabType="type" showType="offer" @dialog="dialog" v-loading="loading" :loading="loading" />
    <list-pagination v-show="CurCount>0" ref="Pagination" :total="CurCount" @getData="getData" />
  </div>
</template>

<script>
import TableList from "@/components/tablelist";
import ListPagination from "@/components/listpagination";
export default {
  name: "",
  components: { TableList, ListPagination },
  data() {
    return {
      loading: true, //page loading
      input: "",
      dialogTitle: "",
      dialogType: "",
      dialogVisible: false,
      UserInfo: this.$store.state.UserInfo,
      List: [],
      CurCount: 0,
      Count: 0,
      toBeAnsweredCount: 0,
      answeredCount: 0,
      dealCount: 0,
      searchKey: '',
      PageIndex: 1,
      PageSize: 60,
      type: 1,//1全部，2未回复，3已成交，4拒绝
    };
  },
  created: function () {
    var that = this;
    const offerType = that.$route.params.type;
    if (offerType) {
      that.type = offerType;
    }
  },
  mounted: function () {
    var that = this;
    that.getData();
  },
  methods: {
    // 获取 我收到的议价 列表
    getData(PageIndex, PageSize) {
      var that = this;//我的 Offer列表
      if (PageIndex && PageSize) { that.PageIndex = PageIndex; that.PageSize = PageSize; }
      let params = `?pageIndex=${that.PageIndex}&pageSize=${that.PageSize}&searchKey=${that.searchKey}&type=${that.type}`;
      that.loading = true;
      that.List = [];
      that.Count = 0;
      let fun = function (res) {
        that.loading = false;
        console.log(res)
        if (res.result) {
          var _data = res.data
          that.List = _data;
          // 统计条数
          that.Count = res.count;
          that.toBeAnsweredCount = res.toBeAnsweredCount;
          that.answeredCount = res.answeredCount;
          that.dealCount = res.dealCount;
          that.setCurCount();
        }
      };
      that.$get('Bid', params)//我收到的议价 列表
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
          that.loading = false;
        });
    },
    // 统计对应的条数
    setCurCount() {
      let that = this;
      switch (this.type) {
        case 1:
          that.CurCount = that.Count;
          break;
        case 2:
          that.CurCount = that.toBeAnsweredCount;
          break;
        case 3:
          that.CurCount = that.dealCount;
          break;
        case 4:
          that.CurCount = that.answeredCount;
          break;
      }
    },
    // 获取对应类型的 我收到的议价 列表
    MsgTabs(val) {
      let that = this;
      that.type = val;
      that.PageIndex = 1;
      that.getData();
    },
    dialog(val, obj) {
      // this.dialogVisible = true;
      // this.dialogType = val;
      // if (val == 0) this.dialogTitle = "Return shipping info";
      // if (val == 1) this.dialogTitle = "Ship";
      // if (val == 2) this.dialogTitle = "Card Description";
      // if (val == 3) this.dialogTitle = "Edit shipping fee";
      // console.log(val, obj);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_tabs {
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/pages/commodity/offer.vue